import { findRoute } from '@/utils/findRoute';

import {
  isStaticPath,
  matchesPrefix,
  type PartnerEntry,
  toDonationPath,
} from './partnerEntry';
import { DONATION_ROUTES, ROUTES } from './routes';

export const KAKAOBANK = {
  ENTRY_TOKEN_KEY: 'kakaobankEntryToken',
  //* 가입 화면이 읽어야 해 httpOnly를 못 쓴다 — domain을 비워 카뱅 호스트로만 범위를 좁힌다
  ENTRY_TOKEN_COOKIE_OPTIONS: { path: '/', secure: true } as const,
} as const;

export const KAKAOBANK_ENTRY_PARAM = 'detail_id';
//* 카뱅 키워드(type·target·detail_id)와 이름이 겹치지 않게 콘텐츠 쿼리를 통째로 한 값에 싣는다
export const KAKAOBANK_ENTRY_QUERY_PARAM = 'query';

export const KAKAOBANK_ENTRY_TARGET = {
  DONATION_HISTORY: 'donation_history',
  ORDER_DETAIL: 'order_detail',
  GIFT_DETAIL: 'gift_detail',
  GIFT_LIST: 'gift_list',
  HOME: 'home',
} as const;

//* 카뱅에서도 웰로 화면을 그대로 쓰는 경로. 고기부 대응 라우트보다 이 목록이 우선이다
//* — `/my/orders`는 `/donation/my/orders`가 실재하지만 메뉴가 가리키는 통합 주문내역은 웰로 쪽이다.
const WELLO_PREFIXES: readonly string[] = [
  DONATION_ROUTES.HOME.pathname,
  ROUTES.LOGIN.pathname,
  ROUTES.EASY_CERTIFICATION.pathname,
  //* prefix 매칭이라 `/join/common`·`/join/complete`·`/join/user-info`를 한 번에 덮는다
  '/join',
  ROUTES.PUSH.pathname,
  ROUTES.MY_EDIT.pathname,
  ROUTES.MY_ORDERS.pathname,
  ROUTES.MY_DELIVERY_ADDRESS.pathname,
  ROUTES.MY_REVIEWS.pathname,
  ROUTES.POINT_MARKET_HISTORY.pathname,
  '/terms',
];

export const resolveKakaobankEntry = (pathname: string): PartnerEntry => {
  if (
    isStaticPath(pathname) ||
    WELLO_PREFIXES.some((prefix) => matchesPrefix(pathname, prefix))
  ) {
    return { kind: 'pass' };
  }

  const donationPath = toDonationPath(pathname);

  //* 대응 라우트가 없으면 접두어를 붙여 404를 만드는 대신 고기부 홈으로 되돌린다.
  return findRoute(donationPath)
    ? { kind: 'redirect', pathname: donationPath }
    : { kind: 'redirect', pathname: DONATION_ROUTES.HOME.pathname };
};
